export function toEmDash(nullValue) {
  if (nullValue === null) {
    return '\u2014';
  }
  return nullValue;
}

export function toMinus(number) {
  if (parseFloat(number) < 0) {
    return `\u2212${number.toString().slice(1)}`;
  }
  return number;
}

export function getEnDash() {
  return '\u2013';
}
